'use client';

import { useState } from 'react';

import { Button, ButtonLink, LinkedInIcon, XIcon } from '@endaoment-frontend/design-system';

interface SocialShareProps {
  title: string;
  url: string;
}

export function SocialShare({ title, url }: SocialShareProps) {
  const [copied, setCopied] = useState(false);
  const encodedUrl = encodeURIComponent(url);

  const shareLinks = [
    {
      label: 'Share on Twitter',
      href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodedUrl}`,
      Icon: XIcon,
    },
    {
      label: 'Share on LinkedIn',
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      Icon: LinkedInIcon,
    },
  ];

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className='flex flex-wrap items-center gap-2'>
      <span className='label mr-2 text-muted'>Share:</span>
      {/* ButtonLink adds target and rel for these external hrefs. */}
      {shareLinks.map(({ label, href, Icon }) => (
        <ButtonLink
          key={label}
          href={href}
          intent='ghost'
          size='sm'
          float={false}
          aria-label={label}
          className='px-2 text-slate-700'>
          <Icon />
        </ButtonLink>
      ))}
      <Button
        intent='ghost'
        size='sm'
        float={false}
        onClick={copyToClipboard}
        aria-label='Copy link'
        className='px-2 text-slate-700'>
        <svg className='size-5' fill='none' stroke='currentColor' viewBox='0 0 24 24' aria-hidden>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z'
          />
        </svg>
      </Button>
      {/* Always in the tree: a live region only announces changes to content it already held. */}
      <span aria-live='polite' className='label text-green-700'>
        {copied ? 'Copied' : ''}
      </span>
    </div>
  );
}
